import {
  pipe,
  split,
  reject,
  drop,
  splitWhen,
  head,
  isEmpty,
  equals,
  toLower,
} from 'ramda';

const HTTPS = 'https:';

const clearUrl = pipe(
  split('/'),
  reject(isEmpty),
  drop(2),
  splitWhen(equals("#")),
  head,
) as (a: string) => string[];

export const domainFolder = (): string => {
  const myUrlList: string[] = clearUrl(window.location.href);
  let myFolder: string = '';

  if (!isEmpty(myUrlList)) {
    myUrlList.forEach((value: string, key: number) => myFolder = `${myFolder}/${value}`);
  }

  return myFolder;
};

export const isSecure = (): boolean => {
  return window.location.protocol.toLowerCase() === HTTPS;
};
